// Angular imports
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

// 3rd party imports
import { DxPopoverComponent } from 'devextreme-angular';
import dxPopover from 'devextreme/ui/popover';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { UserCommunitiesService } from '../../_services/user-communities.service';

// Model imports
import { UserCommunityCoordinatesResultDto } from '../../_models/user-communities/user-community-coordinates-result-dto';
import { UpdateUserCommunityCoordinatesParametersDto } from '../../_models/user-communities/update-user-community-coordinates-parameters-dto';

declare const google: any;

@Component({
    selector: 'app-user-community-map-popover',
    templateUrl: './user-community-map-popover.component.html',
    styleUrls: ['./user-community-map-popover.component.scss']
})
export class UserCommunityMapPopoverComponent {
    @ViewChild(DxPopoverComponent, { static: false }) popover: DxPopoverComponent;

    @Input() isStreetView: boolean;
    @Input() target: string | HTMLElement;
    @Input() selectedMarker: any;
    @Input() selectedCommunity: UserCommunityCoordinatesResultDto;

    @Output() onShown = new EventEmitter<dxPopover>();
    @Output() onHidden = new EventEmitter<dxPopover>();
    @Output() onSave = new EventEmitter<void>();
    @Output() onUpdate = new EventEmitter<boolean>();

    iconEdit = IconConstants.EDIT;
    iconSave = IconConstants.SAVE;
    iconCancel = IconConstants.CANCEL;
    iconLookup = IconConstants.SEARCH;
    iconCheck = IconConstants.CHECK;
    iconCross = IconConstants.CROSS;

    showCoordinatesEditor = false;
    editorParams = new UpdateUserCommunityCoordinatesParametersDto();
    dragEventListener: any;

    constructor(
        private readonly errorService: ServerErrorService,
        private readonly communitiesService: UserCommunitiesService
    ) {
        this.onEditClick = this.onEditClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
    }

    show(target: any): void {
        this.target = target;
        setTimeout(() => this.popover.instance.show(), 10);
    }

    hide(): void {
        if (this.showCoordinatesEditor) {
            this.doCleanUpAndClose(false);
        }
        this.popover.instance.hide();
    }

    option(name: string, value: any): void {
        this.popover.instance.option(name, value);
    }

    repaint(): void {
        this.popover.instance.repaint();
    }

    onEditClick(): void {
        if (this.selectedCommunity && this.selectedMarker) {
            this.editorParams.communityId = this.selectedCommunity.communityId;
            this.editorParams.latitude = this.selectedCommunity.latitude;
            this.editorParams.longitude = this.selectedCommunity.longitude;
            this.selectedMarker.setDraggable(true);
            this.dragEventListener = this.selectedMarker.addListener('dragend', () => {
                const position = this.selectedMarker.getPosition();
                this.editorParams.latitude = position.lat().toFixed(6);
                this.editorParams.longitude = position.lng().toFixed(6);
            });
            this.showCoordinatesEditor = true;
            setTimeout(() => this.onUpdate.emit(true), 10);
        }
    }

    onCancelClick(): void {
        this.editorParams.latitude = this.selectedCommunity.latitude;
        this.editorParams.longitude = this.selectedCommunity.longitude;
        this.doCleanUpAndClose();
    }

    onSaveClick(): void {
        this.communitiesService.updateUserCommunityCoordinates(this.editorParams).subscribe(
            () => {
                this.selectedCommunity.latitude = this.editorParams.latitude;
                this.selectedCommunity.longitude = this.editorParams.longitude;
                this.onSave.emit();
                this.doCleanUpAndClose();
            },
            (error) => {
                this.errorService.displayError(error);
                this.doCleanUpAndClose();
            }
        );
    }

    private doCleanUpAndClose(notifyUpdate = true): void {
        if (!!this.selectedMarker && !!this.dragEventListener) {
            this.selectedMarker.setDraggable(false);
            this.selectedMarker.setPosition(
                new google.maps.LatLng(this.selectedCommunity.latitude, this.selectedCommunity.longitude)
            );
            this.dragEventListener.remove();
        }
        this.showCoordinatesEditor = false;
        if (notifyUpdate) {
            setTimeout(() => this.onUpdate.emit(false), 10);
        }
    }
}
